import React, { useContext, useEffect } from 'react'
import { memo } from 'react'
import Helpers from './Viewer-helpers'
import './Viewer.css'
import { ViewerContext } from '../../context/ViewerContext'

const Viewer = (props) => {
  const { selectedGuidViewCurrentModel, relaunchViewer } =
    useContext(ViewerContext)
  useEffect(() => {
    if (props.urn) {
      Helpers.launchViewer(
        'viewerDiv',
        window.btoa(props.urn),
        props.setAreViewerDbIdsLoaded,
        props.setAllPropertyNames,
        selectedGuidViewCurrentModel
      )
    }
  }, [relaunchViewer])
  return (
    <div
      className="forge-viewer"
      id="viewerDiv"
      style={{ position: 'relative' }}
    />
  )
}

export default memo(Viewer)
